const RecorderStateType = {
  IDLE: Symbol("idle"),
  INSTRUCTIONS: Symbol("instructions"),
  RECORDING: Symbol("recording"),
  PAUSED: Symbol("stopped"),
  FINISHED: Symbol("finished"),
};

export default RecorderStateType;
